import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { selectAllQuotes } from 'src/app/core/services/bp-sdk-store-service/bp-sdk-store.selectors';
import { BpSdkStoreService } from 'src/app/core/services/bp-sdk-store-service/bp-sdk-store.service';
import { QuotesDebugTabItemComponent } from './quotes-debug-tab-item/quotes-debug-tab-item.component';

@Component({
  selector: 'app-quotes-debug-tab',
  templateUrl: './quotes-debug-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatExpansionModule, QuotesDebugTabItemComponent],
})
export class QuotesDebugTabComponent {
  private readonly sdkStoreService = inject(BpSdkStoreService);

  quotes = computed(() => {
    const sdkState = this.sdkStoreService.sdkReadyState();
    if (!sdkState) {
      return [];
    }

    return selectAllQuotes(sdkState);
  });
}
